import { fetch } from "@/helpers/fetch"; //引用fetch.js
/**
 * get
 * -------------------------------------获取openid---------------------------------------------
 *  code 返回的code
 *  type 返回的type
 */
/**
 * @author : sith
 * @Date :  2024-12-06 16:32:06
 * @description : 账号到期提醒
 * @param : 
 */
export function expirationUser(data) {
    return fetch({
        url: `/api/wechat/expiration/user`,
        method: 'get',
        params: data
    })
}